import { TimeEnum, TimeRangeEnum } from "../../../lib/enums";

export const TIME_RANGE_SUGGESTIONS = [
  {
    name: TimeRangeEnum.custom,
    value: "__datepicker"
  },
  {
    name: TimeRangeEnum.today,
    value: TimeEnum.TODAY
  },
  {
    name: TimeRangeEnum.lastWeek,
    value: TimeEnum.LAST_WEEK
  },
  {
    name: TimeRangeEnum.lastMonth,
    value: TimeEnum.LAST_MONTH
  },
  {
    name: TimeRangeEnum.lastQuarter,
    value: TimeEnum.LAST_QUARTER
  },
  {
    name: TimeRangeEnum.lastYear,
    value: TimeEnum.LAST_YEAR
  }
];

export const UNIT_MAP: Record<string, moment.unitOfTime.DurationConstructor> = {
  h: "hours",
  d: "days",
  w: "weeks",
  m: "months",
  y: "years"
};
